import search from './search/reducer';
import notification from './notification/reducer';
import map from './map/reducer';
import appSettings from './appSettings/reducer';
import tabs from './tabs/reducer';
import selectedTab from './selectedTab/reducer';
import ui from './ui/reducer';
import settings from './settings/reducer';
import config from './config/reducer';
import defaultPresets from './defaultPresets/reducer';
import countryRules from './countryrules/reducer';
import selectedCountry from './selectedCountry/reducer';
import activeUser from './selectedUser/reducer';
import supportedCountries from './countries/reducer';

export const appReducers = {
  search,
  notification,
  map,
  appSettings,
  tabs,
  selectedTab,
  ui,
  settings,
  config,
  defaultPresets,
  countryRules,
  selectedCountry,
  activeUser,
  supportedCountries,
};
